module.exports = __webpack_public_path__ + "static/media/product2.f6d22cc4.png";